<template>
  <div>
    <div class="common-form">编辑车费</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="名称">
        <el-input class="max-w460" v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="起步价">
        <el-input class="max-w460" placeholder="请输入起步价" v-model="form.startingPrice" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="低于n公里免费">
        <el-input class="max-w460" v-model="form.minNum" type="number">
          <template slot="append">Km</template>
        </el-input>
      </el-form-item>
      <el-form-item label="每公里价格">
        <el-input class="max-w460" v-model="form.kilometerPrice" type="number">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="公里数">
        <el-input class="max-w460" v-model="form.exceedNum" type="number" placeholder="超出多少公里计算价格(默认计算起步价)">
          <template slot="append">Km</template>
        </el-input>
      </el-form-item>
      <el-form-item label="高峰期开始时间">
        <el-time-select v-model="form.peakStart"
          :picker-options="{
            start: '00:00',
            step: '00:10',
            end: '23:59'
          }" placeholder="选择时间">
        </el-time-select>
      </el-form-item>
      <el-form-item label="高峰期结束时间">
        <el-time-select v-model="form.peakEnd"
          :picker-options="{
            start: '00:00',
            step: '00:10',
            end: '23:59'
          }" placeholder="选择时间">
        </el-time-select>
      </el-form-item>
      <el-form-item label="高峰期起步价">
        <el-input class="max-w460" v-model="form.peakStartingPrice" type="number" placeholder="请输入高峰期起步价">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="高峰期每公里价格">
        <el-input class="max-w460" v-model="form.peakKilometerPrice" type="number" placeholder="请输入高峰期每公里价格">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="高峰期起步公里数">
        <el-input class="max-w460" v-model="form.peakExceedNum" type="number" placeholder="请输入高峰期起步公里数">
          <template slot="append">Km</template>
        </el-input>
      </el-form-item>
      <el-form-item label="是否免费">
        <el-radio-group v-model="form.isFree">
          <el-radio :label="2">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">修改车费</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import fareAPI from "@/api/fare.js";

export default {
  data() {
    return {
      form: {}
    };
  },

  created() {
    this.id = this.$route.query.params.id;
    this.form = this.$route.query.params;
  },

  methods: {
    // 修改技师
    onSubmit() {
      let self = this;
      fareAPI
        .fareEdit(self.form, true)
        .then(res => {
          if (res.code == 1) {
            self.$message(res.msg);
          }
          self.$router.push("/setting/fare_setting/index");
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped lang=''>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/fare_setting/edit.vue